import { BRIEF_TASK_FORMS } from "@entities/brief/lib/constants";
import { BRIEF_CAMPAIGNS_LIST_QUERY_KEY } from "@entities/campaigns/lib/contsants";
import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { ICampaignDeliverableTaskUpload } from "@shared/lib/types/briefCampains";
import { BriefConfigService } from "../services/briefConfigService";

export function useUploadTaskContent(
  briefId: string,
  handleSuccess?: () => void
) {
  const {
    mutate: uploadTaskContent,
    isLoading: isUploading,
    isSuccess: isUploaded,
    variables,
    data,
  } = useMutation({
    mutationFn: ({ data }: { data: ICampaignDeliverableTaskUpload }) =>
      BriefConfigService.uploadTaskContent(data).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      handleSuccess && handleSuccess();
      c.invalidateQueries({
        queryKey: [...BRIEF_CAMPAIGNS_LIST_QUERY_KEY(briefId)],
      });
      c.invalidateQueries({
        queryKey: [...BRIEF_TASK_FORMS(briefId)],
      });
    },
  });

  return {
    uploadTaskContent,
    isUploading,
    isUploaded,
    variables,
    latestVersionId: data?.data?.campaignTaskForm?.draftVersionId,
    draftId: data?.data?.campaignTaskForm?.draftingId,
  };
}
